import { render, staticRenderFns } from "./HoseRecommendations.vue?vue&type=template&id=7d0267f0&scoped=true"
import script from "./HoseRecommendations.vue?vue&type=script&lang=js"
export * from "./HoseRecommendations.vue?vue&type=script&lang=js"
import style0 from "./HoseRecommendations.vue?vue&type=style&index=0&id=7d0267f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0267f0",
  null
  
)

export default component.exports